import React, { FC } from 'react'
import { IStep1ModalButtonsProps } from '../../interfaces/Step'

const Step1ModalButtons: FC<IStep1ModalButtonsProps> = (props) => {
  const { handleModalReUpload, handleModalDismiss } = props

  return (
    <div className="textRight">
      <button
        type="button"
        onClick={handleModalReUpload}
        className="btn btnPrimary mb15 mb0md btnPrimarySm"
      >
        Charger à nouveau
      </button>
      <button
        className="textSecondaryBlack btnUnstyled textUnderline"
        onClick={handleModalDismiss}
        type="submit"
      >
        Poursuivre avec cette pièce
      </button>
    </div>
  )
}

export default Step1ModalButtons
